export interface CalendarDay {
  date: Date;
  inCurrentMonth: boolean;
}

export const startOfDay = (date: Date): Date =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate());

export const isSameDay = (a: Date, b: Date): boolean =>
  a.getFullYear() === b.getFullYear() &&
  a.getMonth() === b.getMonth() &&
  a.getDate() === b.getDate();

export const isWithinRange = (day: Date, start: Date, end: Date): boolean =>
  day.getTime() >= start.getTime() && day.getTime() <= end.getTime();

export const getMonthMatrix = (viewDate: Date): CalendarDay[][] => {
  const year = viewDate.getFullYear();
  const month = viewDate.getMonth();
  const firstWeekday = (new Date(year, month, 1).getDay() + 6) % 7;
  const start = new Date(year, month, 1 - firstWeekday);

  return Array.from({ length: 6 }, (_, week) =>
    Array.from({ length: 7 }, (_, day) => {
      const date = new Date(start);
      date.setDate(start.getDate() + week * 7 + day);
      return { date, inCurrentMonth: date.getMonth() === month };
    }),
  );
};
